<template>
  <div class="noResults d-flex align-items-center justify-content-center mt-3">
    <p class="noResults_text mb-0">
      Não existem registros cadastrados
    </p>
  </div>
</template>

<script>
  export default {
    name: "NoResults"
  }
</script>

<style lang="scss">
  @import '../../../scss/_utilities/exports';

  .noResults {
    border: pxToRem(1) dashed $color-blue;
    border-radius: pxToRem(4);
    min-height: pxToRem(60);

    &_text {
      color: $color-blue;
      font-size: pxToRem(14);
      font-weight: 500;
    }
  }
</style>
